import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import { GlobalStyles } from './GlobalStyles';
import { SettingsProvider } from './contexts/SettingsContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import ChatBox from './components/ChatBox';
import NotFound from './pages/NotFound';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminLogin from './pages/admin/Login';
import AdminHome from './pages/admin/Home';
import AdminCourses from './pages/admin/Courses';
import AdminBlogs from './pages/admin/Blogs';
import AdminHeroSlides from './pages/admin/HeroSlides';
import AdminTestimonials from './pages/admin/Testimonials';
import AdminPartners from './pages/admin/Partners';
import AdminUsers from './pages/admin/Users';
import AdminSettings from './pages/admin/Settings';
import AdminContactForms from './pages/admin/ContactForms';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';

function ChromeAware({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith('/admin');
  return (
    <div className="App">
      {!isAdmin && <Header />}
      <main>
        {children}
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatBox />}
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <SettingsProvider>
          <Router>
            <ScrollToTop />
            <ChromeAware>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/courses" element={<Courses />} />
                  <Route path="/courses/:slug" element={<CourseDetail />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={(<ProtectedRoute><AdminLayout /></ProtectedRoute>)}>
                    <Route index element={<AdminHome />} />
                    <Route path="courses" element={<AdminCourses />} />
                    <Route path="blogs" element={<AdminBlogs />} />
                    <Route path="partners" element={<AdminPartners />} />
                    <Route path="hero-slides" element={<AdminHeroSlides />} />
                    <Route path="testimonials" element={<AdminTestimonials />} />
                    <Route path="users" element={<AdminUsers />} />
                    <Route path="contact-forms" element={<AdminContactForms />} />
                    <Route path="settings" element={<AdminSettings />} />
                  </Route>
                  <Route path="*" element={<NotFound />} />
                </Routes>
            </ChromeAware>
          </Router>
        </SettingsProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;